<div class="page-layout carded fullwidth left-sidebar">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="margin:0px">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
          <h2 class="m-0">{{'CHANGELOG.TITULO' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
          <!-- CONTENT TOOLBAR -->
          <div class="toolbar px-24 py-8">
            <span >{{'CHANGELOG.SUBTITULO' | translate}}</span>
          </div>
          <!-- / CONTENT TOOLBAR -->
          <div class="changelog w100 p-20" fxFlex>
            <div class="entry br-30 mat-elevation-z8 m-40" *ngFor="let version of versiones; first as first;" [ngClass]="{'ultima': first == true}" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">

                <div class="title mb-0" fxLayout="row" fxLayoutAlign="space-between center">
                  <span class="version">{{version.version}} - {{version.title}}</span>
                  <div fxLayout="column" fxLayoutAlign="start end">
                    <em *ngIf="first">{{'CHANGELOG.ULTIMA' | translate}}</em>
                    <span class="date">{{version.createdAt | date: 'longDate' : '' : idiomaActual}}</span>
                  </div>
                </div>
                <mat-divider [inset]="true" class="mtb-20"></mat-divider>
                <div class="groups">

                  <div *ngFor="let nota of version.notes">
                    <mat-chip-list>
                      <mat-chip [color]="nota.type == 'Changed' ? 'primary' : (nota.type == 'Fixed' ? 'accent' : 'false')" selected>
                        {{'CHANGELOG.CATEGORIAS.'+ nota.type | translate}}
                      </mat-chip>
                    </mat-chip-list>
                    <ul>
                        <!-- <li *ngFor="let elemento of nota.list">{{elemento.text}}</li> -->
                        <li *ngFor="let elemento of nota.list" [innerHTML]="elemento.text"></li>
                    </ul>
                  </div>

                </div>

            </div>
          </div>
        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
